import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table as Table2,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Radio,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    Tree,
    Avatar,
    message
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {CloseOutlined, EditOutlined, PlusOutlined} from '@ant-design/icons'
import {
    UploadOutlined,
    DeleteOutlined,
    FormOutlined,
    MinusSquareOutlined,
    PhoneOutlined,
    WechatOutlined,
    MailOutlined,
    HomeOutlined,
    PlusSquareOutlined,
    CheckCircleOutlined,
    UserOutlined,
    CheckOutlined
} from '@ant-design/icons'
import moment from 'moment';

const {Option, OptGroup} = Select;
const {Search, TextArea} = Input;

class Qxedit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: props.id,
            },
            //type2 横  type 纵
            qxlist: [],

            visible: false,
            loading: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        let arr = that.state.condition
        arr.pay_id = that.props.pay_id
        arr.type = that.props.type ? that.props.type : null
        arr.cate = that.props.cate ? that.props.cate : null
        fetch('/Pay/doRemark', {
            method: "POST",
            body: JSON.stringify(that.state.condition)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg)
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false
                    })
                }
            })
    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            fetch('/Pay/remarkView', {
                method: "POST",
                body: JSON.stringify({
                    id: this.props.id,
                    type: that.props.type ? that.props.type : null,
                    cate: that.props.cate ? that.props.cate : null
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.status == 0) {
                        message.error(data.msg)
                        return
                    }
                    that.setState({
                        condition: this.props.id?data.data:{},
                    })
                })
        } else {
            that.setState({
                condition: {
                    id: this.props.id,
                },
                loading: false
            })
        }
    }


    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.condition, {[name]: dateString})
        this.setState({
            condition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Option value={Number(item.id)} key={index}>{item.name}</Option>
            )
        }
    }

    // 上传图片
    picChange(name, info) {
        // console.log(info)
        if (info.file.status === 'uploading') {
            this.setState({ loading2: true });
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info.file.response)

            var fjlist = this.state.condition[name]
            if (!fjlist) {
                fjlist = []
            }
            if (info.file.response.status == 0) {
                message.error(info.file.response.msg)
                return;
            }
            fjlist = fjlist.concat(info.file.response)
            let data = Object.assign({}, this.state.condition, { [name]: fjlist })
            this.setState({
                condition: data,
                loading2: false,
            })
        }
    };

    delpic(index, name, e) {
        var fjlist = this.state.condition[name]
        fjlist.splice(index, 1)
        let data = Object.assign({}, this.state.condition, { [name]: fjlist })
        this.setState({
            condition: data,
        })
    }

    render() {
        return (
            <>
                {this.props.id ?
                    <a href='javascript:void(0)' onClick={this.mdchange.bind(this)}>编辑</a>
                    :
                    <>
                        <a href='javascript:void(0)' style={{color: '#1890ff', fontSize: 14, fontWeight: 'normal'}}
                           onClick={this.mdchange.bind(this)}>添加备注</a>
                    </>
                }

                <Modal title="编辑" maskClosable={false} destroyOnClose={true} width={600}
                       visible={this.state.visible} onCancel={this.mdchange.bind(this)} footer={null}>
                    <Form
                        layout="vertical"
                        // labelCol={{ span: 3 }}
                        wrapperCol={{span: 24}}
                        autoComplete="off"
                    >
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="备注内容"
                                    required={true}
                                >
                                    <TextArea rows={6} placeholder="请输入"
                                              value={this.state.condition.content ? this.state.condition.content : null}
                                              onChange={this.onChange.bind(this, 'content')}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="上传附件"
                                >
                                    <Row justify="space-between">
                                        <Space align="start">
                                            <Upload
                                                showUploadList={false}
                                                action="/Ajax/upload"
                                                onChange={this.picChange.bind(this, 'fjlist')}
                                                multiple={true}
                                                data={{
                                                    pc: 1
                                                }}
                                            >
                                                <Button icon={<UploadOutlined/>}>上传</Button>
                                            </Upload>
                                            <Space wrap direction={"vertical"}>
                                                {this.state.condition.fjlist ? this.state.condition.fjlist.map((item, index) =>
                                                    <div>
                                                        <a href={item.url} target="_blank">{item.name} </a>
                                                        <DeleteOutlined className="hongse"
                                                                        onClick={this.delpic.bind(this, index, 'fjlist')}/>
                                                    </div>) : null}

                                            </Space>
                                        </Space>
                                    </Row>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item>
                                    <Row justify={"center"}>
                                        <Button type='primary' onClick={this.sub.bind(this)}
                                                loading={this.state.loading}>提交</Button>
                                    </Row>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>

                </Modal>
            </>
        )
    }
}

export default Qxedit
